export default theme => ({
  root: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: "transparent",
    zIndex: 100
  },

  contentWrap: {
    backgroundColor: theme.palette.common.white
  },

  topIconsContainer: {
    padding: "0 118px 10px",
    marginBottom: theme.spacing(["5", 1]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 500
  },

  comboChangeSite: {
    cursor: "pointer"
  },

  eccoLogoHeader: {
    fontSize: 190,
    marginTop: -50,
    [theme.breakpoints.down("xs")]: {
      marginBottom: -30,
      marginTop: -40,
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: -30,
      marginTop: -40,
    }
  },

  headerContainer: {
    padding: "0 114px 16px 114px"
  },

  eccoLogo: {
    position: "relative",
    bottom: 20
  },

  logo: {
    position: "absolute",
    fontSize: 210,
    top: -95,
    left: -20
  },

  eccoLinks: {
    fontWeight: theme.typography.fontWeightMedium,
    marginTop: 2
  },

  eccoLink: {
    textTransform: "uppercase",
    fontSize: theme.typography.pxToRem(15),
    padding: `0 ${theme.spacing(["5", 2])}px`,
    color: theme.palette.grey.eccoGrey,
    height: "1em",
    marginRight: 8,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",

    "&:hover, &$active": {
      color: theme.palette.primary.main
    }
  },

  active: {},

  eccoButtonsContainer: {
    display: "flex",
    marginLeft: 8
  },

  buttonHeaderText: {
    fontSize: theme.typography.pxToRem(13)
  },

  headerMenu: {
    height: 300,
    backgroundColor: theme.palette.common.white,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow:
      "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 6px 1px rgba(0,0,0,0.14), 0px 7px 6px 2px rgba(0,0,0,0.12)"
  },

  swissGroupIconWrapped: {
    margin: 0,
    paddingRight: 0,
    height: "100%"
  }
});
